import { render, staticRenderFns } from "./MainAtendimentoChat.vue?vue&type=template&id=5f5c6fb2&"
import script from "./MainAtendimentoChat.vue?vue&type=script&lang=js&"
export * from "./MainAtendimentoChat.vue?vue&type=script&lang=js&"
import style0 from "./MainAtendimentoChat.vue?vue&type=style&index=0&id=5f5c6fb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports